const FieldStateEnum = {
  initial: 'init',
  blur: 'blur',
  focus: 'focus',
  input: 'input',
  submit: 'submit',
};

export default FieldStateEnum;
